(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["husq-product-info"] && !Shopify.designMode) return;
  try {
    
(function () {
  var T_AMT     = '\u007B\u007Bamount\u007D\u007D';
  var T_AMT_ND  = '\u007B\u007Bamount_no_decimals\u007D\u007D';
  var T_AMT_C   = '\u007B\u007Bamount_with_comma_separator\u007D\u007D';
  var T_AMT_NDC = '\u007B\u007Bamount_no_decimals_with_comma_separator\u007D\u007D';

  function formatMoney(cents, format) {
    if (!cents) return '';
    var amount      = (cents / 100).toFixed(2);
    var noDecimals  = String(Math.round(cents / 100));
    // Dutch format: decimal sep = ',', thousands sep = '.'  e.g. 1.299,00
    var amountParts  = amount.split('.');
    var intFormatted = amountParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withComma    = intFormatted + ',' + (amountParts[1] || '00');
    var noDecimalsComma = noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (format || T_AMT)
      .replace(T_AMT, amount)
      .replace(T_AMT_ND, noDecimals)
      .replace(T_AMT_C, withComma)
      .replace(T_AMT_NDC, noDecimalsComma);
  }

  function initProductInfo(section) {
    var sectionId = section.dataset.sectionId;
    var moneyFormat = section.dataset.moneyFormat || T_AMT;
    var textInStock    = section.dataset.textInStock    || 'In voorraad';
    var textOutOfStock = section.dataset.textOutOfStock || 'Uitverkocht';
    var textSave       = section.dataset.textSave       || 'BESPAAR';

    var variantsEl = document.getElementById('husq-pi-variants-' + sectionId);
    if (!variantsEl) return;

    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

    var selectedOptions = {};

    // ── Seed selected options from initial DOM state ──────────────────
    var swatches = section.querySelectorAll('.husq-pi__swatch');
    swatches.forEach(function (s) {
      if (s.classList.contains('husq-pi__swatch--selected')) {
        selectedOptions[parseInt(s.dataset.optionIndex)] = s.dataset.value;
      }
      // Bind click — single pass
      s.addEventListener('click', function () {
        var optionIndex = parseInt(this.dataset.optionIndex);
        var value = this.dataset.value;
        section.querySelectorAll('.husq-pi__swatch[data-option-index="' + optionIndex + '"]').forEach(function (t) {
          t.classList.remove('husq-pi__swatch--selected');
          t.setAttribute('aria-checked', 'false');
        });
        this.classList.add('husq-pi__swatch--selected');
        this.setAttribute('aria-checked', 'true');
        var nameEl = document.getElementById('husq-selected-color-' + sectionId + '-' + optionIndex);
        if (nameEl) nameEl.textContent = value;
        selectedOptions[optionIndex] = value;
        updateUI(findVariant());
      });
    });

    // ── Quantity stepper ─────────────────────────────────────────────
    var qtyWrap  = document.getElementById('husq-qty-wrap-'  + sectionId);
    var qtyInput = document.getElementById('husq-qty-'       + sectionId);
    var qtyMinus = document.getElementById('husq-qty-minus-' + sectionId);
    var qtyPlus  = document.getElementById('husq-qty-plus-'  + sectionId);

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value) || 1;
        var max = parseInt(qtyInput.getAttribute('max')) || 99;
        if (val < max) qtyInput.value = val + 1;
      });
    }

    // ── Thumbnail gallery ─────────────────────────────────────────────
    section.querySelectorAll('.husq-pi__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src    = this.dataset.mediaSrc;
        var srcset = this.dataset.mediaSrcset || '';
        var mainImg = document.getElementById(this.dataset.target);
        if (mainImg && src) {
          mainImg.srcset = srcset;
          mainImg.src    = src;
        }
        section.querySelectorAll('.husq-pi__thumb').forEach(function (t) {
          t.classList.remove('husq-pi__thumb--active');
          t.setAttribute('aria-checked', 'false');
        });
        this.classList.add('husq-pi__thumb--active');
        this.setAttribute('aria-checked', 'true');
      });
    });

    // ── Variant logic ─────────────────────────────────────────────────
    function findVariant() {
      return variants.find(function (v) {
        var keys = Object.keys(selectedOptions);
        for (var i = 0; i < keys.length; i++) {
          var idx = parseInt(keys[i]);
          if (v['option' + (idx + 1)] !== selectedOptions[idx]) return false;
        }
        return true;
      }) || variants[0];
    }

    function updateUI(variant) {
      if (!variant) return;

      var input = document.getElementById('husq-variant-id-' + sectionId);
      if (input) input.value = variant.id;

      // Sync variant in URL so the link is shareable
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* non-fatal */ }

      // Price
      var priceEl = section.querySelector('.husq-pi__price');
      var compareEl = section.querySelector('.husq-pi__compare-price');
      var saveEl = section.querySelector('.husq-pi__save-badge');

      if (priceEl) {
        priceEl.dataset.price = variant.price;
        priceEl.textContent = formatMoney(variant.price, moneyFormat);
      }

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) {
          compareEl.style.display = '';
          var s = compareEl.querySelector('s');
          if (s) s.textContent = formatMoney(variant.compare_at_price, moneyFormat);
        }
        if (saveEl) {
          saveEl.style.display = '';
          saveEl.textContent = textSave + ' ' + formatMoney(variant.compare_at_price - variant.price, moneyFormat);
        }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }

      // CTA row (qty + ATC) vs sold-out button
      var atcBtn    = document.getElementById('husq-atc-'     + sectionId);
      var soldOutEl = document.getElementById('husq-soldout-' + sectionId);

      if (variant.available) {
        if (qtyWrap)    qtyWrap.style.display    = '';
        if (soldOutEl)  soldOutEl.style.display  = 'none';
      } else {
        if (qtyWrap)   qtyWrap.style.display   = 'none';
        if (soldOutEl) soldOutEl.style.display  = '';
      }
      if (qtyInput) qtyInput.value = 1;

      // Stock status — update BOTH color class AND text content (P0 fix)
      var stockEl = document.getElementById('husq-stock-' + sectionId);
      if (stockEl) {
        var dot = stockEl.querySelector('.husq-pi__stock-dot');
        var text = stockEl.querySelector('.husq-pi__stock-text');
        if (dot) {
          dot.className = 'husq-pi__stock-dot ' + (variant.available ? 'husq-pi__stock-dot--in' : 'husq-pi__stock-dot--out');
        }
        if (text) {
          text.className = 'husq-pi__stock-text ' + (variant.available ? 'husq-pi__stock-text--in' : 'husq-pi__stock-text--out');
          text.textContent = variant.available ? textInStock : textOutOfStock;
        }
      }

      // Scarcity badge
      var scarcityEl = document.getElementById('husq-scarcity-' + sectionId);
      if (scarcityEl) {
        var sqty = variant.inventory_quantity;
        var smanaged = variant.inventory_management === 'shopify';
        if (variant.available && smanaged && sqty > 0 && sqty <= 5) {
          scarcityEl.style.display = '';
          var scarcityText = scarcityEl.querySelector('.husq-pi__scarcity-text');
          if (scarcityText) scarcityText.textContent = 'Nog maar ' + sqty + ' op voorraad';
        } else {
          scarcityEl.style.display = 'none';
        }
      }

      // Sticky ATC price + state sync
      var stickyPriceEl = document.getElementById('husq-sticky-price-' + sectionId);
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price, moneyFormat);
      var stickyBtn = document.getElementById('husq-sticky-btn-' + sectionId);
      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
        stickyBtn.textContent = variant.available ? (section.dataset.textAtc || 'In winkelwagen') : (textOutOfStock);
      }

      // Variant image swap — clear srcset so manual src takes precedence
      if (variant.featured_image && variant.featured_image.src) {
        var mainImg = document.getElementById('husq-main-img-' + sectionId);
        if (mainImg) {
          // Modern Shopify CDN: use ?width= query params (robust, format-agnostic)
          var rawSrc = variant.featured_image.src.split('?')[0];
          mainImg.srcset = rawSrc + '?width=400 400w, ' + rawSrc + '?width=800 800w, ' + rawSrc + '?width=1200 1200w';
          mainImg.src    = rawSrc + '?width=800';
        }
      }
    }
  }

  function initAirlinesEntrance() {
    var strips = document.querySelectorAll('.husq-pi__airlines:not(.husq-pi__airlines--visible)');
    if (!strips.length) return;
    if (!window.IntersectionObserver) {
      strips.forEach(function (el) { el.classList.add('husq-pi__airlines--visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('husq-pi__airlines--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    strips.forEach(function (el) { observer.observe(el); });
  }

  function initStickyAtc(section) {
    var sectionId  = section.dataset.sectionId;
    var stickyEl   = document.getElementById('husq-sticky-atc-' + sectionId);
    var mainWrap   = document.getElementById('husq-qty-wrap-'   + sectionId);
    var soldOutEl  = document.getElementById('husq-soldout-'    + sectionId);
    if (!stickyEl) return;

    // Observe both the ATC row and the sold-out button so the sticky bar
    // appears whenever neither is visible (e.g. user has scrolled past them)
    var sentinels = [mainWrap, soldOutEl].filter(Boolean);
    if (!sentinels.length) return;

    if (!window.IntersectionObserver) {
      stickyEl.classList.add('husq-pi__sticky-atc--visible');
      stickyEl.removeAttribute('aria-hidden');
      return;
    }

    var visibleCount = 0;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visibleCount += entry.isIntersecting ? 1 : -1;
      });
      // Show sticky only when no main CTA element is visible
      if (visibleCount <= 0) {
        stickyEl.classList.add('husq-pi__sticky-atc--visible');
        stickyEl.removeAttribute('aria-hidden');
      } else {
        stickyEl.classList.remove('husq-pi__sticky-atc--visible');
        stickyEl.setAttribute('aria-hidden', 'true');
      }
    }, { threshold: 0.5 });

    sentinels.forEach(function (el) { observer.observe(el); });

    // Sticky button click → trigger the main form submit
    var stickyBtn = document.getElementById('husq-sticky-btn-' + sectionId);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.disabled) return;
        var mainAtcBtn = document.getElementById('husq-atc-' + sectionId);
        if (mainAtcBtn && !mainAtcBtn.disabled) {
          mainAtcBtn.click();
          // Mirror loading state briefly on sticky button
          var originalText = stickyBtn.textContent;
          stickyBtn.disabled = true;
          setTimeout(function () {
            stickyBtn.textContent = originalText;
            stickyBtn.disabled = false;
          }, 2200);
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('.husq-product-info').forEach(initProductInfo);
    document.querySelectorAll('.husq-product-info').forEach(initStickyAtc);
    initAirlinesEntrance();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.husq-product-info');
    if (section) initProductInfo(section);
    if (section) initStickyAtc(section);
    // Re-run entrance in editor after section reload
    var strip = e.target.querySelector('.husq-pi__airlines');
    if (strip) strip.classList.add('husq-pi__airlines--visible');
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.closest('.husq-product-info')) return;
    var btn = form.querySelector('.husq-pi__atc-btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var variantInput = form.querySelector('[name="id"]');
    var qInput       = form.querySelector('[name="quantity"]');
    if (!variantInput) return;

    var variantId    = parseInt(variantInput.value, 10);
    var quantity     = parseInt((qInput && qInput.value) || '1', 10);
    var originalHTML = btn.innerHTML;
    var addedText    = btn.dataset.textAdded || '✓ Toegevoegd';

    btn.disabled = true;
    btn.classList.add('husq-pi__atc-btn--loading');

    var cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);
      // Comma-separated string — matches Dawn's product-form.js approach
      formData.append('sections', cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      formData.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) throw new Error(response.description || 'cart_add_failed');

          btn.classList.remove('husq-pi__atc-btn--loading');
          btn.classList.add('husq-pi__atc-btn--success');
          btn.textContent = addedText;

          // Clear empty-state classes before rendering new content
          cartDrawer.classList.remove('is-empty');
          var drawerItems = cartDrawer.querySelector('cart-drawer-items');
          if (drawerItems) drawerItems.classList.remove('is-empty');

          cartDrawer.renderContents(response);

          setTimeout(function () {
            btn.innerHTML = originalHTML;
            btn.classList.remove('husq-pi__atc-btn--success');
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.classList.remove('husq-pi__atc-btn--loading');
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        });

    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart_add_failed');
          return r.json();
        })
        .then(function () {
          btn.classList.remove('husq-pi__atc-btn--loading');
          btn.classList.add('husq-pi__atc-btn--success');
          btn.textContent = addedText;
          return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('.cart-count-bubble [aria-hidden]').forEach(function (el) {
                el.textContent = cart.item_count;
              });
            });
        })
        .then(function () {
          setTimeout(function () {
            btn.innerHTML = originalHTML;
            btn.classList.remove('husq-pi__atc-btn--success');
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.classList.remove('husq-pi__atc-btn--loading');
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
